import * as React from "react";

// Components
import ContactOrganizerForm from "./ContactOrganizerForm";

// Libraries
import {Popup } from "react-map-gl";
import Button from "react-bootstrap/Button";


// Event loading and event detail popups
export default function GoPlayMap(props) {

    // Validate URL
  const isValidHttpUrl = (string) => {
    console.log(string);
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  };


  // Month Names
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Contact organizer state
  const [showContactOrganizerForm, setShowContactOrganizerForm] = React.useState(false);

  // Toggle Contact Organizer Form in Popup
  const handleToggle = () => {
    setShowContactOrganizerForm((current) => !current);
  };

  // Listen for escape to close popups
  React.useEffect(() => {
    // Listen for escape to close
    const listener = (e) => {
      if (e.key === "Escape") {
        props.setSelectedEvent(null);
      }
    };
    window.addEventListener("keydown", listener);
    return () => window.removeEventListener("keydown", listener);
  }, [props]);

  return (
      <>
        <div>

          {/* Loading Event Detail... */}
          {props.selectedEvent && props.loadingEventDetail && (

            <Popup
              latitude={props.selectedEvent.coordinates[1]}
              longitude={props.selectedEvent.coordinates[0]}
              anchor="top"
              onOpen={() => {
                setShowContactOrganizerForm(false)
              }}
              onClose={() => {
                props.setSelectedEvent(null);
                setShowContactOrganizerForm(false);
              }}
              className="event-popup"
            >
              <h4 className="white-color">Loading event details...</h4>
            </Popup>
          )}

          {/* Event Detail Popup */}
          {props.selectedEvent && !props.loadingEventDetail && (

              <Popup
                latitude={props.selectedEvent.coordinates[1]}
                longitude={props.selectedEvent.coordinates[0]}
                focusAfterOpen={false}
                onClose={() => {
                  props.setSelectedEvent(null);
                  setShowContactOrganizerForm(false);
                }}
                anchor="top"
                className="event-popup"
              >

              {/* Event Detail Graphic */}
              <div className="event-popup text-left">

                {/* Title */}
                <h4 className="event-details-title font-weight-bold">
                  {props.eventDetail.title}
                </h4>

                <hr className="white-color"/>

                {/* Date and Time */}
                <h5 className="font-weight-bold green-color">

                  {/* Date */}
                  {month[new Date(props.eventDetail.event_datetime).getMonth()]}{" "}
                  {new Date(props.eventDetail.event_datetime).getDate()}
                  &nbsp;

                  {/* Time */}
                  {new Date(props.eventDetail.event_datetime).toLocaleTimeString(
                    "en-US",
                    {
                      hour12: true,
                      hour: "numeric",
                      minute: "numeric",
                      second: "numeric",
                    }
                  )}
                </h5>

                {/* Street Address */}

                {props.eventDetail.contact_information_public  ? (
                <h6 className="font-weight-bold green-color street-address-text">
                  {props.eventDetail.street_address}
                </h6>
                ) : null}


                {/* Description */}
                <p className="white-color mt-2 mb-2">{props.eventDetail.description}</p>

                {/* Buttons */}

                {/* Event Page Link */}
                {props.eventDetail.link_to_event && props.eventDetail.link_to_event !== 'undefined' && isValidHttpUrl(props.eventDetail.link_to_event) ? (
                    <Button 
                      variant="primary" 
                      className="btn-popup-event-page square  mr-5 rounded-pill b-5 font-weight-bold"
                      href={props.eventDetail.link_to_event}
                      target="_blank"
                      size="sm"
                      >
                        EVENT PAGE
                    </Button>
                ) : null}

                {/* Contact Organizer Toggle */}
                {props.eventDetail.contact_information_public  ? (
                  <Button
                    variant="primary" 
                    className="square rounded-pill b-5 font-weight-bold btn-popup-contact-organizer"
                    //onClick={handleToggle}
                    href={'mailto: ' + props.eventDetail.organizer_email}
                    size="sm"
                    > 
                      CONTACT ORGANIZER
                  </Button>

                //White Horizontal Bar
                //<hr className="white-color"/>

                //Contact Organizer Form will be toggled based on the handleToggle function.
                //{showContactOrganizerForm && <ContactOrganizerForm setShowContactOrganizerForm={setShowContactOrganizerForm} eventDetail={props.eventDetail} />}
                ) : null }

              </div>
            </Popup>
        )}
      </div>
    </>
  );
}
